import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import TitleDetailStreamingChartListItem from '@/components/details/streaming-chart/TitleDetailStreamingChartListItem.vue';
import { streamingChartLandingPageCountries } from '@/components/details/streaming-chart/streaming-chart-config';

import { ObjectType, StreamingChartsTitlesEdge } from '@/@types/graphql-types';

import { timestamp } from '@/helpers/date-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailStreamingChartList',
  props: {
    titles: null,
    titleId: { default: '' },
    titleObjectType: null,
    lastUpdated: null,
    isSidebar: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { titles: StreamingChartsTitlesEdge[], titleId: string, titleObjectType?: ObjectType, lastUpdated?: string | number | Date, isSidebar: boolean };



const { country, language } = useLanguageStore();

const showChart = computed(() => props.titles?.length > 0);

const updatedTimestamp = computed(() => {
	const updated = timestamp(
		props.lastUpdated ?? '',
		{
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		},
		country.value,
		language.value
	);
	return `${updated.time}, ${updated.date}`;
});

const showLinkButton = computed(
	() => !!streamingChartLandingPageCountries.includes(country.value) && language.value === 'en'
);

const linkButtonText = computed(() => {
	if (props.titleObjectType === ObjectType.Movie) return 'Show all movies in the JustWatch Streaming Charts';
	if (props.titleObjectType === ObjectType.Show) return 'Show all TV shows in the JustWatch Streaming Charts';
	if (props.titleObjectType === ObjectType.ShowSeason) return 'Show all seasons in the JustWatch Streaming Charts';
	return 'Show all titles in the JustWatch Streaming Charts';
});

const linkButtonQueryParams = computed(() => {
	let objectTypeQueryParam = undefined;
	if (props.titleObjectType === ObjectType.Show) objectTypeQueryParam = 'shows';
	if (props.titleObjectType === ObjectType.ShowSeason) objectTypeQueryParam = 'seasons';
	return {
		t: objectTypeQueryParam,
		ct: 'daily',
	};
});

function getChartPosition(title: StreamingChartsTitlesEdge) {
	return title?.streamingChartInfo?.rank;
}

function getChartPositionDynamic(title: StreamingChartsTitlesEdge) {
	return title?.streamingChartInfo?.trend;
}

function getChartMovement(title: StreamingChartsTitlesEdge) {
	return title?.streamingChartInfo?.trendDifference;
}

function getDaysInTop1000(title: StreamingChartsTitlesEdge) {
	return title.streamingChartInfo?.daysInTop1000;
}

function getTitleName({ node }: StreamingChartsTitlesEdge) {
	if (node.objectType === ObjectType.Movie || node.objectType === ObjectType.Show) {
		return node?.content?.title;
	}

	if (node.objectType === ObjectType.ShowSeason) {
		return node?.show?.content?.title;
	}

	return '';
}

function getShowSeason({ node }: StreamingChartsTitlesEdge) {
	if (node.objectType === ObjectType.ShowSeason) {
		return node?.content?.seasonNumber;
	}
	return null;
}

function isTitle(title: StreamingChartsTitlesEdge) {
	return title?.node?.id === props.titleId;
}

function trackLinkClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'redirect_clicked',
		label: 'streaming_chart',
	});
}

return { __sfc: true,props, country, language, showChart, updatedTimestamp, showLinkButton, linkButtonText, linkButtonQueryParams, getChartPosition, getChartPositionDynamic, getChartMovement, getDaysInTop1000, getTitleName, getShowSeason, isTitle, trackLinkClick, TitleDetailStreamingChartListItem }
}

})